<template>
  <v-layout
    class="mt-4"
    wrap
  >
    <v-flex xs12>
      <v-layout wrap>
        <ConsentInstruction v-if="showConsentInstruction && !is2019Edition" />
        <v-flex
          v-if="is2019Edition"
          class="mt-2"
        >
          <v-layout
            align-center
            justify-content-between
            :justify-center="xsScreen"
            :wrap="xsScreen"
            :class="[xsScreen ? 'py-2' : '']"
          >
            <v-flex
              px-2
              class="f-16 fw-600"
            >
              <p>{{ $t('family_card.document_section.instruction_for_2019_edition') }}</p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="!is2019Edition && isPostMeetingConsentSet"
          xs12
        >
          <v-layout
            align-center
            justify-content-between
            class="documents-row"
            :justify-center="xsScreen"
            :wrap="xsScreen"
            :class="[xsScreen ? 'py-2' : '']"
          >
            <v-flex
              xs6
              sm6
              md5
              xl4
              :class="[xsScreen ? 'mb-2' : '']"
            >
              <v-layout
                align-center
                wrap
              >
                <v-flex xs12>
                  <v-layout align-center>
                    <baseIcon class="mr-2">
                      <fileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                    </baseIcon>
                    <p class="mb-0 f-1 mr-3">
                      <span class="fw-600">
                        {{
                          $t(
                            'family_card.document_section.post_meeting_consent_instruction.post_meeting_consent'
                          )
                        }}
                      </span>
                    </p>
                    <a
                      v-if="postMeetingConsentUrl"
                      :href="postMeetingConsentUrl"
                      target="_blank"
                    >
                      <baseIcon
                        width="32"
                        height="32"
                        class="mt-1"
                      >
                        <PdfIcon :icon-color="$vuetify.theme.sz_violet" />
                      </baseIcon>
                    </a>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          xs12
          pb-2
        >
          <v-divider />
        </v-flex>
        <v-flex
          v-if="sheetInstruction"
          class="mt-2"
        >
          <v-layout
            align-center
            justify-content-between
            :justify-center="xsScreen"
            :wrap="xsScreen"
            :class="[xsScreen ? 'py-2' : '']"
          >
            <v-flex
              px-2
              class="f-16"
            >
              <p>{{ $t('family_card.document_section.instruction_1') }}</p>
              <p>{{ $t('family_card.document_section.instruction_2') }}</p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-for="(item, index) in documentsList"
          :key="index"
          xs12
          :class="`order-xs${item.order}`"
        >
          <v-layout
            v-if="item.visible"
            align-center
            justify-content-between
            class="documents-row"
            :justify-center="xsScreen"
            :wrap="xsScreen"
            :class="[xsScreen ? 'py-2' : '']"
          >
            <v-flex
              xs6
              sm6
              md5
              xl4
              :class="[xsScreen ? 'mb-2' : '']"
            >
              <v-layout
                align-center
                wrap
              >
                <v-flex xs12>
                  <v-layout align-center>
                    <baseIcon
                      v-if="
                        item.icon &&
                          item.title === $t('family_card.document_section.resend_notification')
                      "
                      :viewBox="'0 0 50 50'"
                      :width="22"
                      class="mr-2"
                    >
                      <MailIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                    </baseIcon>
                    <baseIcon
                      v-else-if="item.icon"
                      class="mr-2"
                    >
                      <fileIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                    </baseIcon>
                    <p class="mb-0 f-1">
                      <span class="fw-600">{{ item.title }}</span>
                      <span v-if="item.subtitle"> - {{ item.subtitle }}</span>
                    </p>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="item.hasComment && item.hasComment.isComment && isCurrentEdition"
              align-center
              class="none-growth"
            >
              <v-tooltip bottom>
                <template
                  slot="activator"
                  slot-scope="{ on }"
                >
                  <div v-on="on">
                    <v-layout
                      align-center
                      justify-start
                      row
                      fill-height
                    >
                      <v-flex>
                        <v-icon :color="$vuetify.theme.sz_red">
                          notifications
                        </v-icon>
                      </v-flex>
                      <v-flex v-if="$vuetify.breakpoint.smAndUp">
                        <span>{{ $t('family_card.document_section.audit_comment') }}</span>
                        <span
                          v-if="item.hasComment && item.hasComment.comments"
                          class="fw-600"
                        >
                          {{ item.hasComment.comments.length | brackets }}</span>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
                <span>{{
                  statusDescription(getComments(item.hasComment.comments, 'national'))
                }}</span>
              </v-tooltip>
            </v-flex>
            <v-spacer />
            <v-flex class="none-growth">
              <div v-if="resendMailItem(item.title)">
                <v-btn
                  color="sz_violet"
                  class="mx-0"
                  :disabled="!isCurrentEdition"
                  @click="openMailModal()"
                >
                  {{ $t('buttons.resend') }}
                </v-btn>
              </div>
              <div v-else>
                <v-btn
                  v-if="isCurrentEdition && item.status"
                  :id="item.id"
                  color="sz_violet"
                  class="mx-0"
                  @click="redirect(item.title, item.id)"
                >
                  {{ $t('buttons.edit') }}
                </v-btn>
                <router-link
                  v-else
                  :to="{ name: routerName(item.title), params: { familyId } }"
                >
                  {{ $t('buttons.preview') }}
                </router-link>
                <v-btn
                  v-if="canResendGiftGivingReportMail(item)"
                  :disabled="!isCurrentEdition"
                  color="sz_violet"
                  class="mx-0 ml-3"
                  @click="openGiftGivingReportMailModal"
                >
                  {{ $t('buttons.resend') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="showPublishedLinksRow"
          xs12
          order-xs4
        >
          <v-layout
            align-center
            justify-content-between
            class="documents-row"
            :justify-center="xsScreen"
            :wrap="xsScreen"
            :class="[xsScreen ? 'py-2' : '']"
          >
            <v-flex
              xs12
              sm6
              :class="[xsScreen ? 'mb-2' : '']"
            >
              <v-layout
                align-center
                wrap
              >
                <v-flex xs12>
                  <v-layout align-center>
                    <baseIcon
                      :viewBox="'0 0 50 50'"
                      :width="22"
                    >
                      <LinkIcon :icon-color="$vuetify.theme.sz_medium_grey" />
                    </baseIcon>
                    <p class="mb-0 ml-2 f-1 fw-600">
                      {{ publicatedLinksSectionTitle }}
                    </p>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-spacer />
            <v-flex class="none-growth">
              <div
                v-if="showNativeWarehouseLink"
                class="text-sm-right text-xs-center"
              >
                <a
                  class="d-block"
                  target="_blank"
                  :href="getSWRLink(nativeWarehouse?.warehouse_id)"
                >{{ nativeWarehouse?.warehouse_name }}</a>
              </div>
              <a
                v-else-if="chosenWarehouse && anotherChosenWarehouse"
                class="d-block"
                target="_blank"
                :href="getSWRLink(chosenWarehouse?.warehouse_id)"
              >{{ chosenWarehouse?.warehouse_name }}</a>
              <v-expansion-panel
                v-if="!chosenWarehouse && supportingWarehouses.length > 0"
                class="inlined text-sm-right text-xs-center"
              >
                <v-expansion-panel-content>
                  <template slot="header">
                    <p class="mb-1 f-1">
                      {{ $t('label.available_in_warehouses') }}
                    </p>
                  </template>
                  <a
                    v-for="(item, index) in supportingWarehouses"
                    :key="index"
                    class="d-block"
                    target="_blank"
                    :href="getSWRLink(item?.warehouse_id)"
                  >{{ item?.warehouse_name }}</a>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="!is2019Edition"
        wrap
      >
        <SpecialistPackageDocumentsList />
      </v-layout>
      <v-layout
        v-if="!is2019Edition"
        wrap
      >
        <FurtherStoryList />
      </v-layout>
      <AppModal
        :visible="showMailModal"
        @close="closeMailModal()"
      >
        <template slot="title">
          <h2 class="display-3 display-3_dark text-xs-left">
            {{ $t('family_card.document_section.mail_modal.title') }}
          </h2>
        </template>
        <template slot="content">
          <p class="f-1 mb-0">
            {{ $t('family_card.document_section.mail_modal.instruction') }}
          </p>
        </template>
        <template slot="actions">
          <v-layout
            align-center
            class="my-2"
            :column="$vuetify.breakpoint.xsOnly"
            :justify-space-between="$vuetify.breakpoint.smAndUp"
          >
            <v-flex
              order-xs2
              order-sm1
              class="lh-1 none-growth"
              :class="[$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mr-4']"
            >
              <a @click="closeMailModal()">{{ $t('buttons.cancel') }}</a>
            </v-flex>
            <v-flex
              order-xs1
              order-sm2
              class="none-growth"
            >
              <v-btn
                color="sz_violet"
                :loading="resendLoader"
                :disabled="resendLoader"
                @click="resendMail()"
              >
                {{ $t('buttons.send') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
      </AppModal>
    </v-flex>
    <AppModal
      :visible="showGiftMailModal"
      @close="closeGiftGivingReportMailModal()"
    >
      <template slot="title">
        <h2 class="display-3 display-3_dark text-xs-left">
          {{ $t('family_card.document_section.gift_giving_report_mail_modal.title') }}
        </h2>
      </template>
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('family_card.document_section.gift_giving_report_mail_modal.instruction') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[$vuetify.breakpoint.xsOnly ? 'mt-2' : 'mr-4']"
          >
            <a @click="closeGiftGivingReportMailModal">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :loading="resendGiftGivingReportMailLoader"
              :disabled="resendGiftGivingReportMailLoader"
              @click="resendGiftGivingReportMail"
            >
              {{ $t('buttons.send') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="confirmationModalVisibility"
      persistent
      :close-button="false"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ confirmationTitle }}
        </p>
      </template>
      <template slot="actions">
        <v-layout wrap>
          <v-flex
            xs12
            class="mt-1 mb-4"
          >
            <v-layout
              justify-center
              align-center
              :wrap="$vuetify.breakpoint.xs"
            >
              <v-flex class="none-growth">
                <v-btn
                  color="sz_violet"
                  @click="closeConfirmationModal()"
                >
                  {{ $t('buttons.ok') }}
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="showPreviousEditionCheck"
      :close-button="!noUserResponse"
      persistent
      @close="closePreviousEditionCheck()"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ similarFamilyModalText }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-end="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            v-if="responseNoContent === false && similarityParameters.chosenOption == null"
            order-xs2
            order-sm1
            class="lh-1 none-growth mr-auto"
            :class="[$vuetify.breakpoint.xsOnly ? 'mt-3 mr-0' : 'mr-auto']"
          >
            <a @click="closePreviousEditionCheck">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :disabled="checkPreviousEditionsLoader"
              :loading="checkPreviousEditionsLoader"
              @click="checkDuplicateInPreviousEdition"
            >
              {{ noUserResponse ? $t('buttons.ok') : $t('buttons.check') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="isGluedModal"
      :close-button="false"
      persistent
    >
      <template slot="content">
        <v-layout
          align-center
          mt-3
        >
          <v-flex
            shrink
            pa-2
            pl-0
          >
            <v-icon color="sz_red">
              warning
            </v-icon>
          </v-flex>
          <v-flex
            shrink
            pa-2
            pr-0
          >
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-1 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.title') }}
            </h2>
            <h2 class="text-xs-left f-16 sz_grafit--text ma-0 mt-2 font-weight-regular">
              {{ $t('alikes_families.p_e.glued_warning.text') }}
            </h2>
          </v-flex>
        </v-layout>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-end
        >
          <v-btn
            color="sz_violet"
            @click="closeGluedModal()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="showDuplicateDialog"
      :close-button="true"
      persistent
      @closeButton="closeDuplicateModal"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('alikes_families.p_e.duplicate_modal.text') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-end
        >
          <a
            class="mr-auto"
            @click="closeDuplicateModal()"
          >{{ $t('buttons.cancel') }}</a>
          <v-btn
            color="sz_violet"
            :disabled="checkPreviousEditionsLoader"
            :loading="checkPreviousEditionsLoader"
            @click="connectFamilyDuplicate"
          >
            {{ $t('buttons.connect') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <SimilarFamiliesPreviousEdition
      v-model="previousEditionModel"
      :loading="checkPreviousEditionsLoader"
      @close="previousEditionModel = false"
      @addNewFamily="leaveFamily"
      @forDecision="leaveToDecision"
      @overwriteFamily="connectFamily"
    />
  </v-layout>
</template>

<script>
import baseIcon from '@/icons/BaseIcon';
import fileIcon from '@/icons/FileIcon';
import LinkIcon from '@/icons/LinkIcon';
import MailIcon from '@/icons/MailIcon';

import SimilarFamiliesPreviousEdition from '@/components/widgets/addFamily/SimilarFamiliesPreviousEdition';
import ConsentInstruction from '@/components/widgets/meetingConsent/ConsentInstruction';
import editionsId from '@/constants/editionsId';
import PdfIcon from '@/icons/PdfIcon';
import auditPermissionsAndStatuses from '@/mixins/auditPermissionsAndStatuses';
import familyWarehouses from '@/mixins/familyWarehouses';

import postMeetingConsentConst from '@/constants/sheet/postMeetingConsent';

import FurtherStoryList from '@/components/widgets/FamilyCard/FurtherStoryList';
import SpecialistPackageDocumentsList from '@/components/widgets/FamilyCard/SpecialistPackageDocumentsList';
import filters from '@/constants/filters';

import httpStatusCode from 'http-status-codes';
import AppModal from '@/components/widgets/AppModal.vue';

export default {
    name: 'DocumentsList',
    components: {
        FurtherStoryList,
        SpecialistPackageDocumentsList,
        ConsentInstruction,
        PdfIcon,
        SimilarFamiliesPreviousEdition,
        baseIcon,
        fileIcon,
        AppModal,
        LinkIcon,
        MailIcon
    },
    filters: { ...filters },
    mixins: [familyWarehouses, auditPermissionsAndStatuses, postMeetingConsentConst],
    props: {
        familyId: {
            default: null,
            required: true,
            type: Number
        },
        familyStatus: {
            required: true
        },
        edition: {
            required: true
        },
        isChecked: {
            default: true
        }
    },
    data () {
        return {
            documentsList: [
                {
                    title: this.$t('family_card.documents.1.title'),
                    subtitle: this.$t('family_card.documents.1.subtitle'),
                    status: null,
                    visible: true,
                    icon: true,
                    id: 'sheetOne',
                    order: 1,
                    hasComment: false
                },
                {
                    title: this.$t('family_card.documents.2.title'),
                    subtitle: this.$t('family_card.documents.2.subtitle'),
                    status: null,
                    visible: true,
                    icon: true,
                    id: 'sheetTwo',
                    order: 2,
                    hasComment: false
                },
                {
                    title: this.$t('family_card.documents.3.title'),
                    subtitle: this.$t('family_card.documents.3.subtitle'),
                    status: null,
                    visible: true,
                    icon: true,
                    id: 'description',
                    order: 3,
                    hasComment: false
                },
                {
                    title: this.$t('family_card.document_section.resend_notification'),
                    status: null,
                    visible: null,
                    id: 'resendMail',
                    order: 5,
                    icon: true
                },
                {
                    title: this.$t('family_card.documents.4.title'),
                    status: null,
                    visible: true,
                    icon: true,
                    order: 6,
                    hasComment: false,
                    id: 'giftGivingReport'
                }
            ],
            httpStatusCode,
            showMailModal: false,
            confirmationModalVisibility: false,
            confirmationTitle: '',
            hasPermissionForResendMail: null,
            hasPermissionForResendGiftMail: null,
            hasPermissionForPublishedLinksRow: null,
            showGiftMailModal: false,
            resendLoader: false,
            resendGiftGivingReportMailLoader: false,
            hasPermissionsForNationalCorrecting: null,
            showPreviousEditionCheck: false,
            checkPreviousEditionsLoader: null,
            previousEditionModel: false,
            responseNoContent: false,
            isGluedModal: false,
            currentRoute: null,
            showDuplicateDialog: false,
            duplicateGlued: false,
            editionsId
        };
    },
    computed: {
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        is2019Edition () {
            return this.edition.edition_id === this.editionsId.EDITION_2019;
        },
        smAndDownScreen () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        xsScreen () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        sheetPermissions () {
            return this.$store.getters['sheet/getSheetPermissions'];
        },
        availableStatusesForResendMail () {
            return [
                this.statusesId.HAS_GIFTGIVER,
                this.statusesId.GIFT_GIVING_REPORT_DESCRIBED,
                this.statusesId.GIFT_GIVING_REPORT_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH
            ];
        },
        canResendMail () {
            return (
                this.hasPermissionForResendMail &&
        this.availableStatusesForResendMail.includes(this.familyStatusId)
            );
        },
        statusesForGiftGivingReportMailResend () {
            return [
                this.statusesId.GIFT_GIVING_REPORT_SEND,
                this.statusesId.STATUS_FURTHER_STORY,
                this.statusesId.STATUS_FINISHED_SUMMARY
            ].includes(this.familyStatus.family_edition_status_id);
        },
        availableStatusesForPublishedLinks () {
            return [
                this.statusesId.PUBLISHED,
                this.statusesId.HAS_GIFTGIVER,
                this.statusesId.GIFT_GIVING_REPORT_DESCRIBED,
                this.statusesId.GIFT_GIVING_REPORT_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_AREA_REACH,
                this.statusesId.GIFT_GIVING_REPORT_BACK_NATIONAL_REACH,
                this.statusesId.GIFT_GIVING_REPORT_SEND
            ];
        },
        showPublishedLinksRow () {
            return (
                this.availableStatusesForPublishedLinks.includes(this.familyStatusId) &&
        this.hasPermissionForPublishedLinksRow &&
        this.edition.current === true
            );
        },
        hasGiftGiverAndHigherStatus () {
            const statuses = [
                this.statusesId.HAS_GIFTGIVER,
                this.statusesId.GIFT_GIVING_REPORT_DESCRIBED,
                this.statusesId.GIFT_GIVING_REPORT_CHECKING,
                this.statusesId.GIFT_GIVING_REPORT_SEND
            ];
            return statuses.includes(this.familyStatusId);
        },
        showNativeWarehouseLink () {
            return (
                (this.nativeWarehouse && !this.chosenWarehouse) ||
        (this.chosenWarehouse && !this.anotherChosenWarehouse)
            );
        },
        publicatedLinksSectionTitle () {
            return this.chosenWarehouse
                ? this.$t('family_card.publicated_links_section.familyChosenTitle')
                : this.$t('family_card.publicated_links_section.title');
        },
        allAuditComments () {
            return this.$store.getters['audit/getAllComments'];
        },
        sheetInstruction () {
            return [
                this.statusesId.CREATING_DESCRIPTION,
                this.statusesId.SEND_BACK_AREA_REACH,
                this.statusesId.SEND_BACK_NATIONAL_REACH,
                this.statusesId.FAMILY_VERIFIED_AREA_REACH,
                this.statusesId.FAMILY_VERIFIED_NATIONAL_REACH,
                this.statusesId.CREATING_SECOND_SHEET
            ].includes(this.familyStatusId);
        },
        checkPreviousEditions () {
            return this.isChecked !== true;
        },
        similarityParameters () {
            return this.$store.getters['familyData/getSimilarityParameters']
                ? this.$store.getters['familyData/getSimilarityParameters']
                : {
                    chosenOption: null,
                    chosenFamily: null
                };
        },
        similarFamilyModalText () {
            if (this.responseNoContent) {
                return this.$t('alikes_families.p_e.modal.no_content');
            }
            if (this.similarityParameters.chosenOption === 1) {
                return this.$t('alikes_families.p_e.modal.option_1');
            }
            if (this.similarityParameters.chosenOption === 2) {
                return this.$t('alikes_families.p_e.modal.option_2');
            }
            return this.$t('alikes_families.p_e.modal.default');
        },
        noUserResponse () {
            return this.responseNoContent === true || this.similarityParameters.chosenOption != null;
        },
        showConsentInstruction () {
            return ![
                this.statusesId.GIFT_GIVING_REPORT_SEND,
                this.statusesId.STATUS_FURTHER_STORY,
                this.statusesId.STATUS_FINISHED_SUMMARY
            ].includes(this.familyStatusId);
        }
    },
    watch: {
        sheetPermissions: {
            handler (val) {
                this.sheetPermissionsUpdate(val);
            },
            deep: true,
            immediate: true
        },
        canEditSheets: {
            handler () {
                this.sheetPermissionsUpdate(this.sheetPermissions);
            },
            immediate: true
        },
        canResendMail: {
            handler (val) {
                this.documentsList.find(
                    (el) => el.title === this.$t('family_card.document_section.resend_notification')
                ).visible = val;
            }
        },
        activeGiftGivingReportButton: {
            handler (val) {
                this.documentsList.find(
                    (el) => el.title === this.$t('family_card.documents.4.title')
                ).status = val;
            },
            immediate: true
        },
        hasPermissionsForNationalCorrecting: {
            handler () {
                this.sheetPermissionsUpdate(this.sheetPermissions);
            }
        },
        allAuditComments () {
            this.updateComments();
        },
        hasPermissionForEditGiftGivingReport () {
            this.updateComments();
        },
        familyStatusId () {
            this.sheetPermissionsUpdate(this.sheetPermissions);
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', this.permissions.RESEND_MAIL).then((result) => {
            this.hasPermissionForResendMail = result;
        });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.RESEND_GIFT_GIVING_REPORT_NOTIFICATION)
            .then((result) => {
                this.hasPermissionForResendGiftMail = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.SHEET_CORRECTING_NATIONAL)
            .then((result) => {
                this.hasPermissionsForNationalCorrecting = result;
            });
        this.$store
            .dispatch('auth/hasPermission', this.permissions.FAMILY_CHOICE_PATH_LINK_VIEW)
            .then((result) => {
                this.hasPermissionForPublishedLinksRow = result;
            });
        this.updateComments();
    },
    methods: {
        sheetPermissionsUpdate (val) {
            this.documentsList.forEach((el) => {
                switch (el.title) {
                case this.$t('family_card.documents.1.title'):
                    el.status = val.meeting;

                    if (this.isPublicationRevoked) {
                        el.status = this.hasPermissionsForNationalCorrecting;
                    }
                    if (
                        !this.canEditSheets ||
              (this.isFamilyVerifiedOnNational && !this.hasPermissionsForNationalCorrecting)
                    ) {
                        el.status = false;
                    }

                    break;
                case this.$t('family_card.documents.2.title'):
                    el.status = val.needs;

                    if (this.isPublicationRevoked) {
                        el.status = this.hasPermissionsForNationalCorrecting;
                    }
                    if (
                        !this.canEditSheets ||
              (this.isFamilyVerifiedOnNational && !this.hasPermissionsForNationalCorrecting)
                    ) {
                        el.status = false;
                    }

                    break;
                case this.$t('family_card.documents.3.title'):
                    el.status = val.description;

                    if (this.isPublicationRevoked) {
                        el.status = this.hasPermissionsForNationalCorrecting;
                    }
                    if (
                        !this.canEditSheets ||
              (this.isFamilyVerifiedOnNational && !this.hasPermissionsForNationalCorrecting)
                    ) {
                        el.status = false;
                    }

                    break;
                }
            });
        },
        routerName (name) {
            switch (name) {
            case this.$t('family_card.documents.1.title'):
                return 'sheet-one-meeting';
            case this.$t('family_card.documents.2.title'):
                return 'sheet-two';
            case this.$t('family_card.documents.3.title'):
                return 'family-description';
            case this.$t('family_card.documents.4.title'):
                return 'gift_giving_report';
            }
        },
        openMailModal () {
            this.showMailModal = true;
        },
        closeMailModal () {
            this.showMailModal = false;
        },
        resendMail () {
            this.resendLoader = true;
            this.$store
                .dispatch('giftgiver/resendMail', this.familyId)
                .then(() => {
                    this.closeMailModal();
                    this.confirmationTitle = this.$t('family_card.document_section.mail_modal.confirmation');
                    this.openConfirmationModal();
                })
                .finally(() => {
                    this.resendLoader = false;
                });
        },
        resendMailItem (title) {
            return title === this.$t('family_card.document_section.resend_notification');
        },
        canResendGiftGivingReportMail (item) {
            return (
                this.family.gift_giver != null &&
        this.statusesForGiftGivingReportMailResend &&
        this.hasPermissionForResendGiftMail &&
        item.title === this.$t('family_card.documents.4.title')
            );
        },
        resendGiftGivingReportMail () {
            this.resendGiftGivingReportMailLoader = true;
            this.$store
                .dispatch('giftgiver/resendGiftGivingReportMail', this.familyId)
                .then(() => {
                    this.closeGiftGivingReportMailModal();
                    this.confirmationTitle = this.$t('audit.send_gift_giving_report_confirmation');
                    this.openConfirmationModal();
                })
                .finally(() => {
                    this.resendGiftGivingReportMailLoader = false;
                });
        },
        openGiftGivingReportMailModal () {
            this.showGiftMailModal = true;
        },
        closeGiftGivingReportMailModal () {
            this.showGiftMailModal = false;
        },
        openConfirmationModal () {
            this.confirmationModalVisibility = true;
        },
        closeConfirmationModal () {
            this.confirmationModalVisibility = false;
            this.confirmationTitle = '';
        },
        closePreviousEditionCheck () {
            this.showPreviousEditionCheck = false;
        },
        redirect (title, id) {
            if (title === this.$t('family_card.documents.4.title') && this.canSendPreCreateGift) {
                this.$store.dispatch('giftGivingReport/preCreateGivingReport', this.familyId);
            }
            if (this.checkPreviousEditions) {
                this.showPreviousEditionCheck = true;
                this.currentRoute = this.routerName(title);
            } else {
                this.$router.push({ name: this.routerName(title), params: { familyId: this.familyId } });
            }
        },
        getSWRLink (id) {
            return `${process.env.VUE_APP_SWR_PATH}/rodzina/${this.familyId}/${id}`;
        },
        hasComment (sheetType) {
            if (this.showSheetCommentMark !== true) {
                return false;
            }
            if (
                this.allAuditComments.some((el) => {
                    return el.sheet_type === sheetType;
                })
            ) {
                const comments = this.allAuditComments.find((el) => {
                    return el.sheet_type === sheetType;
                }).data;
                return {
                    isComment: comments && comments.length > 0,
                    comments
                };
            }
            return false;
        },
        hasGiftGivingReportComment () {
            const sheetType = 'gift_giving_report';
            if (this.showGiftAuditCard !== true) {
                return false;
            }

            if (
                this.allAuditComments.some((el) => {
                    return el.sheet_type === sheetType;
                })
            ) {
                const comments = this.allAuditComments.find((el) => {
                    return el.sheet_type === sheetType;
                }).data;
                return {
                    isComment: comments && comments.length > 0,
                    comments
                };
            }
            return false;
        },
        getComments (comments, type) {
            const result = comments.filter((el) => {
                return el && el.level === type;
            });
            return result && result.length > 0;
        },
        statusDescription (isNational) {
            if (this.$vuetify.breakpoint.smAndDown) {
                return isNational
                    ? this.$t('family_card.document_section.national_reach_mobile')
                    : this.$t('family_card.document_section.area_reach_mobile');
            }
            return isNational
                ? this.$t('family_card.document_section.national_reach')
                : this.$t('family_card.document_section.area_reach');
        },
        updateComments () {
            this.documentsList.forEach((document) => {
                if (document.id === 'sheetOne') {
                    const meeting = this.hasComment('meeting');
                    const reflection = this.hasComment('reflection');
                    const decision = this.hasComment('decision');

                    if (meeting.isComment || reflection.isComment || decision.isComment) {
                        const allComments = meeting.comments
                            .concat(reflection.comments)
                            .concat(decision.comments);
                        document.hasComment = {
                            isComment: true,
                            comments: allComments
                        };
                    } else {
                        document.hasComment = false;
                    }
                }
                if (document.id === 'sheetTwo') {
                    document.hasComment = this.hasComment('needs');
                }
                if (document.id === 'description') {
                    document.hasComment = this.hasComment('description');
                }
                if (document.id === 'giftGivingReport') {
                    document.hasComment = this.hasGiftGivingReportComment();
                }
            });
        },
        checkFamilyPreviousEditions () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/checkPreviousEditions', this.familyId)
                .then(({ data }) => {
                    this.showPreviousEditionCheck = false;
                    this.$store.commit('familyData/assignFamilyData', this.$store.getters['family/getFamily']);
                    this.$store.commit('familyData/setSimilarFamilies', data);
                    this.$store.dispatch('familyData/formatSimilarFamilies', data);
                    this.previousEditionModel = true;
                })
                .catch((e) => {
                    this.responseNoContent = e.response.status === 404;
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                });
        },
        checkDuplicateInPreviousEdition () {
            if (this.noUserResponse) {
                if (this.similarityParameters.chosenOption === 2) {
                    this.$router.push({ name: this.currentRoute, params: { familyId: this.familyId } });
                    this.previousEditionModel = false;
                    this.showPreviousEditionCheck = false;
                    this.$store.commit('familyData/setSimilarityParameters', null);
                }
                if (this.responseNoContent === true) {
                    this.checkPreviousEditionsLoader = true;
                    this.$store
                        .dispatch('familyData/markAsCheckedPreviousEditions', this.familyId)
                        .then(() => {
                            this.$router.push({ name: this.currentRoute, params: { familyId: this.familyId } });
                        })
                        .finally(() => {
                            this.checkPreviousEditionsLoader = false;
                            this.showPreviousEditionCheck = false;
                            this.previousEditionModel = false;
                            this.$store.commit('familyData/setSimilarityParameters', null);
                        });
                } else {
                    this.$store.commit('familyData/setSimilarityParameters', null);
                    this.previousEditionModel = false;
                    this.responseNoContent = false;
                    this.showPreviousEditionCheck = false;
                }
                return;
            }

            if (this.checkPreviousEditionsLoader === true) {
                return;
            }
            this.checkPreviousEditionsLoader = true;

            this.$store
                .dispatch('familyData/checkDuplicateInPreviousEdition', this.$route.params.id)
                .then((response) => {
                    this.showDuplicateDialog = true;
                    this.checkPreviousEditionsLoader = false;
                })
                .catch((e) => {
                    const status = e.response && e.response.status;
                    if (status === this.httpStatusCode.NOT_FOUND) {
                        this.checkFamilyPreviousEditions();
                    } else {
                        this.checkPreviousEditionsLoader = false;
                    }
                });
        },
        closeDuplicateModal () {
            if (this.checkPreviousEditionsLoader === true) {
                return;
            }
            this.showDuplicateDialog = false;
            this.showPreviousEditionCheck = false;
        },
        connectFamilyDuplicate () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/connectFamilyDuplicate', {
                    familyId: this.$route.params.id
                })
                .then(({ data }) => {
                    this.isGluedModal = !!data.data.is_glued;
                    this.duplicateGlued = this.isGluedModal;
                    this.$store.commit('family/setFamily', data.data);
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                    this.closeDuplicateModal();
                    if (this.isGluedModal !== true) {
                        this.$router.push({ name: this.currentRoute, params: { familyId: this.familyId } });
                    }
                });
        },
        leaveFamily () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/markAsCheckedPreviousEditions', this.familyId)
                .then(() => {
                    this.$router.push({ name: this.currentRoute, params: { familyId: this.familyId } });
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                    this.previousEditionModel = false;
                });
        },
        leaveToDecision () {
            this.previousEditionModel = false;
            this.showPreviousEditionCheck = true;
        },
        connectFamily () {
            this.checkPreviousEditionsLoader = true;
            this.$store
                .dispatch('familyData/connectFamily', {
                    familyId: this.familyId,
                    familyToConnectId: this.similarityParameters.chosenFamily
                })
                .then(({ data }) => {
                    this.isGluedModal = !!data.data.is_glued;
                })
                .finally(() => {
                    this.checkPreviousEditionsLoader = false;
                    this.previousEditionModel = false;
                    this.showPreviousEditionCheck = !this.isGluedModal;
                });
        },
        closeGluedModal () {
            this.isGluedModal = false;
            if (this.duplicateGlued !== true) {
                this.showPreviousEditionCheck = true;
            }
            this.duplicateGlued = false;
            this.$router.push({ name: this.currentRoute, params: { familyId: this.familyId } });
        }
    }
};
</script>

<style scoped lang="scss">
.documents-row {
  &:last-of-type {
    border-bottom: none;
  }
}

.v-chip.desktop-thin-chip {
  &v-chip--outline.theme--light,
  &.theme--light {
    margin-top: 0;
    border: 1px solid #ff5900 !important;
    height: 7px !important;
  }
}

.mobile-btn {
  .v-btn__content {
    padding-top: 5px;
  }

  .v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat) {
    height: 19px;
    width: 19px;
    box-shadow: unset;
  }
}
</style>
